import * as Swetrix from 'swetrix';

const BOT_USER_AGENT_PATTERN = /bot|crawl|spider|slurp|headless|lighthouse|pagespeed|preview|facebookexternalhit|twitterbot|linkedinbot|whatsapp|telegrambot|discordbot|ahrefs|semrush|mj12bot|dotbot|python|curl|wget|httpclient/i;

const isBrowser = () => typeof window !== 'undefined' && typeof navigator !== 'undefined';

export const isLikelyBot = () => {
    if (!isBrowser()) return true;
    if (navigator.webdriver) return true;

    const userAgent = navigator.userAgent || '';
    return BOT_USER_AGENT_PATTERN.test(userAgent);
};

export const shouldTrackCustomEvents = ({ automatic = false } = {}) => {
    if (process.env.TESTMODE) return false;
    if (process.env.PRERENDER === 'true') return false;
    if (!isBrowser()) return false;
    if (isLikelyBot()) return false;

    // Page-load events can be multiplied by bots/crawlers. Keep them opt-in only.
    if (automatic && process.env.REACT_APP_SWETRIX_AUTO_EVENTS !== 'true') return false;

    return true;
};

export const trackCustomEvent = (event, options = {}) => {
    if (!shouldTrackCustomEvents(options)) return false;
    Swetrix.track(event);
    return true;
};
